import React from 'react';
export function Footer() {
  return <footer className="bg-neutral-950 text-gray-500 py-12 px-4 border-t border-gray-900 text-center" data-id="element-104">
      <div className="max-w-4xl mx-auto" data-id="element-105">
        <p className="text-sm mb-6 leading-relaxed" data-id="element-106">
          Disclaimer: The information provided in The 2026 Vitality Bundle is
          for educational purposes only and is not intended as medical advice.
          Always consult with a qualified healthcare professional before
          starting any new diet, exercise, or lifestyle protocol, especially if
          you have pre-existing health conditions. Results may vary based on
          individual effort and biological factors.
        </p>
        <div className="flex flex-wrap justify-center gap-4 text-sm mb-6" data-id="element-107">
          <a href="#" className="hover:text-amber-500 transition-colors" data-id="element-108">
            Terms of Service
          </a>
          <span data-id="element-109">|</span>
          <a href="#" className="hover:text-amber-500 transition-colors" data-id="element-110">
            Privacy Policy
          </a>
          <span data-id="element-111">|</span>
          <a href="#" className="hover:text-amber-500 transition-colors" data-id="element-112">
            Contact Support
          </a>
        </div>
        <p className="text-xs" data-id="element-113">
          &copy; {new Date().getFullYear()} The Vitality Code. All rights
          reserved.
        </p>
      </div>
    </footer>;
}